import { getAssert, getElse } from "../../utils/Safe";
import FlumpKeyframeSymbol from "./FlumpKeyframeSymbol";

/**
 * TODO - Add description.
 */
export default class FlumpLayerSymbol
{
    /**
     * @param {*} json - JSON object for the layer.
     */
    constructor(json)
    {
        /** @type {string} */
        this.name = getAssert([json, "name"], "[FlumpLayerSymbol] Cannot find FlumpLayerSymbol name");
        
        // Safely get these properties.
        let keyframeData = getAssert([json, "keyframes"], "[FlumpLayerSymbol] Cannot find keyframes.");
        let keyframeCount = getElse([keyframeData, "length"], 0);

        /** @type {FlumpKeyframeSymbol[]} */
        this.keyframes = new Array(keyframeCount);
        /** @type {number} */
        this.frames = 0;
        var prevKf = null;
        
        for(var i = 0; i < keyframeCount; i++)
        {
            prevKf = new FlumpKeyframeSymbol(keyframeData[i], prevKf);
            this.keyframes[i] = prevKf;
        }
        
        if(prevKf != null)
        {
            this.frames = prevKf.index + prevKf.duration;
        }
        else
        {
            this.frames = 0;
        }
    }  

    /**
     * Cleans up the FlumpLayerSymbol.
     */
    destroy()
    {
        if (this.keyframes != null)
        {
            while (this.keyframes.length > 0)
            {
                this.keyframes[0] = null;
                this.keyframes.shift();
            }
            this.keyframes = null;
        }

        this.game = null;
    }
}